import { conditionFormChecker, putField } from "../../../../utils/form";
import { createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { defineAsyncComponent } from "vue";
import {
    createFieldInput, createFieldRadioGroup
} from "../../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";

const HazObjectCoordinateList = defineAsyncComponent(() => import("./HazObjectCoordinateList"));

export const callSpeciesByGroup = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SPECIES", value: searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.hazSubStance.refSpecies"),
            dataIndex: "refSpecies.value",
            customRender: ({ record }) => <div>{record.refSpecies?.value}</div>,
            inputProp: () => ({ list: callSpeciesByGroup, optLabel: "value" }),
            align: "center",
            width: 80,
            search: { name: "refSpecies.id" }
        }),
        createColumnInput({ title: () => i18n.global.t("model.hazObject.nameTh"), dataIndex: "nameTh", align: "left", width: 250 }),
        createColumnInput({ title: () => i18n.global.t("model.hazObject.nameEn"), dataIndex: "nameEn", align: "left", width: 250 }),
        createColumnInput({
            title: () => i18n.global.t("model.coordinateCustoms.name"),
            dataIndex: "hazObjectCoordinates.refCoordinateCustoms.name",
            align: "left",
            width: 350,
            sorter: false,
            customRender: ({ record }) => {
                const map = record.hazObjectCoordinates?.map(d => <div>{d.refCoordinateCustoms.name}-{d.refCoordinateCustoms.code} {d.refCoordinateCustoms.refDetailSubStanceType?.value || ''}</div>) || [];
                return <div>{...map}</div>
            },
        }),
        createColumnInput({
            visible: () => false,
            title: () => i18n.global.t("model.coordinateCustoms.code"),
            dataIndex: "hazObjectCoordinates.refCoordinateCustoms.code",
        }),
    ]
    return columns
}

export const createField = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSpecies`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazSubStance.refSpecies"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSpecies,
                            "onUpdate:value": value => (model.refSpecies = value),
                            disabled: viewOnly,
                            list: callSpeciesByGroup,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                visible: () =>  true,
                key: `${prefix}refSpecies`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}nameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazObject.nameTh")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.nameTh,
                            "onUpdate:value": value => (model.nameTh = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}nameEn`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazObject.nameEn")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.nameEn,
                            "onUpdate:value": value => (model.nameEn = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => conditionFormChecker({ props, data, executeKey: "visibleSection", params: { sectionKey: "hazObjectCoordinate" } }),
                key: `${prefix}hazObjectCoordinates`,
                colProp: () => ({ xs: 24 }),
                label: () => i18n.global.t("model.coordinateCustoms.modelName"),
                formItemRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: "hazObjectCoordinates"
                        },
                        conditionFormChecker({ props, data, executeKey: "componentProp", params: { sectionKey: "hazObjectCoordinate" } })
                    );
                    return (<div class="mt-2">
                        <HazObjectCoordinateList {...componentProp}></HazObjectCoordinateList>
                    </div>);
                },
                changeLog: { getValueChildren: ({ record }) => record.refCoordinateCustoms?.name+" - "+record.refCoordinateCustoms?.refDetailSubStanceType?.value }
            },

            createFieldInput({
                visible: () => false,
                key: `${prefix}isActive`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazObject.isActive")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.isActive,
                            "onUpdate:value": value => (model.isActive = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};